import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPagesBySlug } from "../../services/apiService";
import useSlug from "../SlugComp";
import SEO from "../Seo";
import parse from "html-react-parser";

// Blog content map - can be expanded with more blog posts
const blogContentMap = {
  "global-capability-center": {
    id: 1,
    title: "Global Capability Center (GCCs)",
    category: "Global Capability Center",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200",
    date: "July 9, 2026",
    author: "TechProjects",
    readTime: "8 minutes",
    excerpt:
      "Discover how Artificial Intelligence is transforming enterprise software, automation, and customer experiences.",
    content: [
      {
        type: "heading2",
        text: "Global Capability Center (GCCs): The Strategic Engines Powering Global Business Transformation",
      },
      {
        type: "paragraph",
        text: "A Global Capability Center (GCC) is a dedicated offshore or nearshore center owned by a multinational company that delivers critical business functions such as software development, cybersecurity, finance, analytics, and research. GCCs have evolved into innovation hubs that support artificial intelligence, digital transformation, cloud adoption, and enterprise growth worldwide.",
      },
      {
        type: "paragraph",
        text: 'What began as cost-saving offshore operations has transformed into a powerful business model driving digital transformation, artificial intelligence (AI), cybersecurity, product engineering, and enterprise innovation. Today, <a href="https://techprojects.com/services/gcc" class="text-blue-600 hover:text-blue-800">GLOBAL CAPABILITY CENTERS</a> are no longer back-office support units; they are central to business growth and strategic decision-making.',},
      {
        type: "heading2",
        text: "What Is a Global Capability Centre (GCC)?",
      },
      {
        type: "paragraph",
        text: "A Global Capability Center (GCC) is a wholly owned offshore or nearshore center established by a multinational company to manage and deliver key business functions. These centers provide specialized expertise in technology, finance, analytics, operations, customer support, cybersecurity, and research and development.",
      },
      {
        type: "paragraph",
        text: "Unlike outsourcing models that rely on third-party vendors, GCCs operate under the direct ownership and control of the parent organization. This enables companies to maintain higher levels of governance, security, quality, and innovation.",
      },
      {
        type: "heading3",
        text: "Key Characteristics of GCCs",
      },
      // {
      //   type: "paragraph",
      //   text: "AI-powered tools like GitHub Copilot and ChatGPT can generate code snippets, suggest completions, and even write entire functions. This not only speeds up development but also helps junior developers learn best practices.",
      // },
      {
        type: "bulletList",
        items: [
          "Owned and operated by the parent organization",
          "Focus on strategic business functions",
          "Access to global talent pools",
          "Strong alignment with corporate goals",
          "Enhanced data security and compliance",
          "Long-term innovation and transformation capabilities",
        ],
      },
      {
        type: "heading2",
        text: "The Evolution of Global Capability Center",
      },
      {
        type: "heading3",
        text: "Phase 1: Cost Optimization",
      },
      {
        type: "paragraph",
        text: "The initial objective of GCCs was to reduce operational expenses by leveraging talent in lower-cost regions.",
      },
      {
        type: "heading3",
        text: "Phase 2: Process Excellence",
      },
      {
        type: "paragraph",
        text: "Organizations expanded GCC responsibilities to include finance, HR, procurement, customer support, and shared services.",
      },
      {
        type: "heading3",
        text: "Phase 3: Technology Enablement",
      },
      {
        type: "paragraph",
        text: 'As <a href="https://techprojects.com/services/gcc" class="text-blue-600 hover:text-blue-800">digital transformation companies in India</a> accelerated, GCCs began supporting software development, cloud infrastructure, data analytics, and enterprise technology initiatives.',
      },
      {
        type: "heading3",
        text: "Phase 4: Innovation Hubs",
      },
      {
        type: "paragraph",
        text: "Today’s GCCs serve as innovation centers focused on:",
      },
      {
        type: "bulletList",
        items: [
          "Artificial Intelligence",
          "Machine Learning",
          "Product Engineering",
          "Cybersecurity",
          "Data Science",
          "Cloud Computing",
          "Digital Experience Platforms",
          "Enterprise Automation",
        ],
      },
      {
        type: "heading2",
        text: "Why Global Capability Centers Are Growing Rapidly",
      },
      {
        type: "paragraph",
        text: "Several factors are driving the global expansion of GCCs.",
      },
      {
        type: "heading3",
        text: "Access to Specialized Talent",
      },
      {
        type: "paragraph",
        text: "Organizations need highly skilled professionals in emerging technologies such as AI, cloud computing, cybersecurity, and advanced analytics. GCCs provide access to a diverse talent ecosystem capable of supporting global operations.",
      },
      {
        type: "heading3",
        text: "Accelerating Digital Transformation",
      },
      {
        type: "paragraph",
        text: "Companies rely on GCCs to modernize legacy systems, develop digital products, automate business processes, and implement next-generation technologies.",
      },
       {
        type: "heading3",
        text: "Operational Efficiency",
      },
      {
        type: "paragraph",
        text: "Centralized operations improve consistency, governance, productivity, and scalability across global business units.",
      },
      {
        type: "heading3",
        text: "Innovation at Scale",
      },
      {
        type: "paragraph",
        text: "Modern GCCs function as research and innovation centers that help organizations create new products, improve customer experiences, and explore emerging technologies.",
      },
       {
        type: "heading2",
        text: "Core Functions Managed by GCCs",
      },
      {
        type: "heading3",
        text: "Technology and Software Development",
      },
      {
        type: "paragraph",
        text: "Many GCCs are responsible for:",
      },
      {
        type: "bulletList",
        items: [
          "Application Development",
          "Enterprise Software Engineering",
          "Mobile App Development",
          "Cloud Architecture",
          "DevOps Operations",
          "Platform Engineering",
        ],
      },
      {
        type: "heading3",
        text: "Cybersecurity Operations",
      },
      {
        type: "paragraph",
        text: "As cyber threats increase globally, organizations use GCCs to strengthen security capabilities.",
      },
      {
        type: "paragraph",
        text: "Key cybersecurity services include:",
      },
      {
        type: "bulletList",
        items: [
          "Security Operations Centers (SOC)",
          "Threat Intelligence",
          "Vulnerability Management",
          "Incident Response",
          "Compliance Monitoring",
          "Risk Assessment"
        ],
      },
      {
        type: "heading3",
        text: "Data Analytics and Business Intelligence",
      },
     
      {
        type: "paragraph",
        text: "GCCs support data-driven decision-making through:",
      },
      {
        type: "bulletList",
        items: [
          "Predictive Analytics",
          "Business Intelligence Reporting",
          "Data Visualization",
          "Customer Analytics",
          "Market Research"
        ],
      },
      {
        type: "heading3",
        text: "Finance and Accounting",
      },
     
      {
        type: "paragraph",
        text: "Financial functions commonly managed by GCCs include:",
      },
      {
        type: "bulletList",
        items: [
          "Accounts Payable",
          "Accounts Receivable",
          "Financial Planning",
          "Audit Support",
          "Regulatory Reporting"
        ],
      },
      {
        type: "heading3",
        text: "Human Resources",
      },
     
      {
        type: "paragraph",
        text: "HR operations often include:",
      },
      {
        type: "bulletList",
        items: [
          "Recruitment",
          "Employee Onboarding",
          "Payroll Management",
          "Learning and Development",
          "Workforce Analytics"
        ],
      },
      {
        type: "heading2",
        text: "Why India Is the Global Leader in GCCs",
      },
      {
        type: "paragraph",
        text: "India has established itself as the world's leading destination for Global Capability Centers.",
      },
       {
        type: "heading3",
        text: "Vast Skilled Workforce",
      },
     
      {
        type: "paragraph",
        text: "India produces millions of graduates annually across engineering, technology, management, finance, and data science disciplines.:",
      },
       {
        type: "heading3",
        text: "Mature Technology Ecosystem",
      },
     
      {
        type: "paragraph",
        text: "Cities such as Bengaluru, Hyderabad, Chennai, Pune, Mumbai, and Gurgaon offer advanced infrastructure and thriving innovation ecosystems.",
      },
      {
        type: "heading3",
        text: "Cost-Effective Operations",
      },
     
      {
        type: "paragraph",
        text: "Organizations benefit from access to high-quality talent while maintaining operational efficiency.",
      },
      {
        type: "heading3",
        text: "Strong Government Support",
      },
     
      {
        type: "paragraph",
        text: "Digital initiatives, infrastructure development, and favorable business policies continue to attract multinational investments.",
      },
      {
        type: "heading3",
        text: "Thriving Startup Ecosystem",
      },
     
      {
        type: "paragraph",
        text: "Collaboration between GCCs, startups, and technology providers creates an environment conducive to innovation.",
      },
      {
        type: "heading2",
        text: "Benefits of Establishing a Global Capability Center",
      },
      {
        type: "heading3",
        text: "1. Access to Global Talent",
      },
     
      {
        type: "paragraph",
        text: "Organizations can recruit specialists across multiple domains and technologies.",
      },
      {
        type: "heading3",
        text: "2. Enhanced Innovation",
      },
     
      {
        type: "paragraph",
        text: "GCCs foster collaboration and experimentation that accelerate product development and business transformation.",
      },
      {
        type: "heading3",
        text: "3. Improved Business Agility",
      },
     
      {
        type: "paragraph",
        text: "Companies can rapidly scale operations and respond to market changes.",
      },
      {
        type: "heading3",
        text: "4. Stronger Governance",
      },
     
      {
        type: "paragraph",
        text: "Direct ownership ensures greater control over processes, security, and compliance.",
      },
      {
        type: "heading3",
        text: "5. Long-Term Cost Efficiency",
      },
     
      {
        type: "paragraph",
        text: "While initial investments may be significant, GCCs often deliver sustainable operational savings.",
      },
      {
        type: "heading3",
        text: "6. Competitive Advantage",
      },
     
      {
        type: "paragraph",
        text: "Organizations gain access to innovation, expertise, and digital capabilities that strengthen market positioning.",
      },
      {
        type: "heading2",
        text: "Challenges Faced by GCCs",
      },
      {
        type: "paragraph",
        text: "Despite their advantages, GCCs must address several challenges.",
      },
      {
        type: "heading3",
        text: "Talent Retention",
      },
     
      {
        type: "paragraph",
        text: "Competition for skilled professionals remains intense across technology and digital domains.",
      },
      {
        type: "heading3",
        text: "Regulatory Compliance",
      },
     
      {
        type: "paragraph",
        text: "Organizations must comply with data protection regulations and industry-specific standards.",
      },
      {
        type: "heading3",
        text: "Cybersecurity Risks",
      },
     
      {
        type: "paragraph",
        text: "Expanding digital operations increases exposure to cyber threats.",
      },
      {
        type: "heading3",
        text: "Cultural Integration",
      },
     
      {
        type: "paragraph",
        text: "Global collaboration requires strong communication and organizational alignment.",
      },
      {
        type: "heading2",
        text: "The Future of Global Capability Centers",
      },
      {
        type: "paragraph",
        text: "The future of GCCs is expected to be defined by innovation, intelligence, and business transformation.",
      },
      {
        type: "paragraph",
        text: "Key developments will include:",
      },
       {
        type: "bulletList",
        items: [
          "AI-Driven Operations",
          "Hyperautomation",
          "Advanced Analytics",
          "Digital Product Engineering",
          "Cybersecurity Innovation",
          "Sustainable Business Practices",
          "Intelligent Enterprise Platforms"
        ],
      },
      {
        type: "paragraph",
        text: "Rather than serving as operational support units, GCCs will increasingly act as strategic growth engines responsible for driving enterprise-wide transformation and innovation.",
      },
      {
        type: "heading2",
        text: "Conclusion",
      },
      {
        type: "paragraph",
        text: "Global Capability Centers have evolved from cost-saving operational units into strategic innovation hubs that drive digital transformation, artificial intelligence adoption, cybersecurity excellence, and business growth. As enterprises continue to embrace emerging technologies and global talent strategies, GCCs will remain at the center of innovation and competitive advantage.",
      },
      {
        type: "heading2",
        text: "Frequently Asked Questions (FAQs)",
      },
      {
        type: "heading3",
        text: "What does GCC stand for?",
      },
      {
        type: "paragraph",
        text: "GCC stands for Global Capability Center, a strategic offshore or nearshore business unit owned by a multinational company.",
      },
      {
        type: "heading3",
        text: "What is the difference between GCC and outsourcing?",
      },
      {
        type: "paragraph",
        text: "A GCC is owned and managed by the parent company, while outsourcing involves delegating work to an external third-party service provider.",
      },
      {
        type: "heading3",
        text: "Why are companies investing in GCCs?",
      },
      {
        type: "paragraph",
        text: "Organizations establish GCCs to access talent, improve operational efficiency, accelerate innovation, strengthen cybersecurity, and support digital transformation.",
      },
      {
        type: "heading3",
        text: "Which country has the largest GCC ecosystem?",
      },
      {
        type: "paragraph",
        text: "India currently hosts the largest and fastest-growing GCC ecosystem globally.",
      },
      {
        type: "heading3",
        text: "What industries use GCCs?",
      },
      {
        type: "paragraph",
        text: "Industries leveraging GCCs include:",
      },
      {
        type: "bulletList",
        items: [
          "Information Technology",
          "Banking and Financial Services",
          "Healthcare",
          "Manufacturing",
          "Retail",
          "Telecommunications",
          "Pharmaceuticals",
          "Logistics"
        ],
      },

    ],
    relatedArticles: [
      // {
      //   title: "Cloud Migration Best Practices",
      //   image:
      //     "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400",
      //   category: "Cloud",
      //   slug: "cloud-migration-best-practices",
      // },
      // {
      //   title: "React Performance Optimization",
      //   image:
      //     "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400",
      //   category: "React",
      //   slug: "react-performance-optimization",
      // },
      // {
      //   title: "DevOps Automation with CI/CD",
      //   image:
      //     "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=400",
      //   category: "DevOps",
      //   slug: "devops-automation-cicd",
      // },
    ],
  },
};

function BlogDetail() {
  let slug = useSlug();
  const [metaData, setMetaData] = useState({});
  useEffect(() => {
    const fetchMetaData = async () => {
      const data = await getPagesBySlug(slug);
      setMetaData(data?.meta || {});
    };
    fetchMetaData();
  }, [slug]);
  // slug = useParams();
  console.log(slug+ "test")
  const navigate = useNavigate();
  const blog = blogContentMap["global-capability-center"];

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Blog post not found
          </h2>
          <p className="text-gray-600 mb-8">
            The article you're looking for doesn't exist.
          </p>
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            Back to Blog
          </button>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    return blog.content.map((section, index) => {
      switch (section.type) {
        case "heading2":
          return (
            <h2
              key={index}
              className="text-3xl font-bold text-gray-900 mt-8 mb-4"
            >
              {parse(section.text)}
            </h2>
          );
        case "heading3":
          return (
            <h3
              key={index}
              className="text-2xl font-bold text-blue-600 mt-6 mb-3"
            >
              {parse(section.text)}
            </h3>
          );
        case "paragraph":
          return (
            <p key={index} className="text-gray-700 leading-relaxed mb-4">
              {parse(section.text)}
            </p>
          );
        case "bulletList":
          return (
            <ul key={index} className="list-disc list-inside space-y-2 mb-4 text-gray-700">
              {section.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          );
        default:
          return null;
      }
    });
  };

  return (
    <>
      {/* Hero Section with Image */}
      <section
        className="relative h-96 md:h-[500px] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('${blog.image}')`,
        }}
      >
        <div className="text-center max-w-3xl px-4">
          <span className="inline-block bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
            {blog.category}
          </span>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {blog.title}
          </h1>
          <p className="text-lg text-gray-100">
            Discover how Global Capability Centers (GCCs) are transforming businesses through innovation, AI, cybersecurity, and digital transformation. Learn benefits, trends, and future opportunities.
          </p>
        </div>
      </section>

      {/* Article Content */}
      <SEO {...metaData} />
      <section className="py-12 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Article Meta */}
          <div className="mb-8 pb-8 border-b border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-600 mb-1">By {blog.author}</p>
              <p className="text-gray-600">{blog.date}</p>
            </div>
            <div>
              <span className="text-sm text-gray-600">
                Estimated read time: {blog.readTime}
              </span>
            </div>
          </div>

          {/* Article Body */}
          <div className="prose prose-lg max-w-none">
            {renderContent()}

            {/* Call to Action */}
            {/* <div className="mt-8 p-6 bg-blue-50 border-l-4 border-blue-600 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Ready to Transform Your Development Process?
              </h3>
              <p className="text-gray-700 mb-4">
                TechProjects specializes in AI-driven software solutions and
                digital transformation. Our experts can help you integrate AI
                into your development workflows efficiently and securely.
              </p>
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
                onClick={() => {
                  window.location.href = "/Contact";
                }}
              >
                Get Started Today
              </button>
            </div> */}
          </div>

          {/* Share Section */}
          <div className="mt-8 pt-8 border-t border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-700 font-semibold">Share this article:</p>
            </div>
            <div className="flex gap-3">
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Facebook
              </button>
              <button className="bg-blue-400 hover:bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Twitter
              </button>
              <button className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                LinkedIn
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Related Articles */}
      {/* <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Related Articles
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blog.relatedArticles.map((article, index) => (
              <div
                key={index}
                className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
                onClick={() => navigate(`/blog/${article.slug}`)}
              >
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="p-6">
                  <span className="inline-block bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-xs font-semibold mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-bold text-gray-900">{article.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Back to Blog Button */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            ← Back to Blog
          </button>
        </div>
      </section>
    </>
  );
}

export default BlogDetail;
